import React from "react";
import usePasses from "../../Passes/hooks/usePasses";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import SinglePass from "../../Passes/SinglePass";
import { replaceVariablesInString } from "./replaceVariablesInString";

interface IProps {
  saleStep: SaleStep;
}

const PassModule: React.FC<IProps> = ({ saleStep }) => {
  const { passes, selectedDate, setDateBetween, loading } = usePasses({
    assortIds: saleStep.assortIds,
    colorIds: saleStep.colorIds,
    shapeIds: saleStep.shapeIds,
    assortGroupIds: saleStep.assortGroupIds,
  });

  const highlightedFeatures = [
    saleStep.highlightedFeature1,
    saleStep.highlightedFeature2,
    saleStep.highlightedFeature3,
  ].filter(Boolean);

  if (loading) return <EASkeletonLoader height="200px" />;

  if (passes.length > 0)
    return (
      <div className="module-list">
        {passes.map((item) => (
          <SinglePass
            key={item.objectId}
            item={item}
            saleStep={saleStep}
            selectedDate={selectedDate}
            setDateBetween={setDateBetween}
            isHorizontal
            highlightBanner={saleStep.highlightBanner}
            bannerLabel={replaceVariablesInString(saleStep.bannerLabel, item)}
            customMainPrice={saleStep.mainPrice}
            crossedPrice={saleStep.crossedPrice}
            additionalPriceInfo={saleStep.priceLabel}
            highlightedFeatures={highlightedFeatures}
          />
        ))}
      </div>
    );

  return <></>;
};

export default PassModule;
